import React from 'react';
import { Button, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import Dialog from './ActionDialog';
import { useTranslation } from 'react-i18next';

export default function RoomConflictDialog({ conflict, busy, onCancel, onConfirm }) {
    const { t } = useTranslation();
    const creating = conflict?.requestedAction === 'CREATE_ROOM';
    const random = conflict?.requestedAction === 'RANDOM_MATCH';
    return <Dialog open={!!conflict} onClose={busy ? undefined : onCancel} fullWidth maxWidth="sm">
        <DialogTitle>{t('roomMembership.conflictTitle')}</DialogTitle>
        <DialogContent>{t(random ? 'roomEntry.switchWarning' : creating ? 'roomMembership.createWarning' : 'roomMembership.joinWarning', {
            currentRoomId: conflict?.currentRoomType === 1 ? t('roomEntry.randomRoom') : conflict?.currentRoomId || '',
            requestedRoomId: conflict?.requestedRoomType === 1 ? t('roomEntry.randomRoom') : conflict?.requestedRoomId || '',
        })}</DialogContent>
        <DialogActions>
            <Button disabled={busy} onClick={onCancel}>{t('common.cancel')}</Button>
            <Button disabled={busy} variant="contained" onClick={onConfirm}>{t(random ? 'roomEntry.leaveAndMatch' : creating ? 'roomMembership.leaveAndCreate' : 'roomMembership.leaveAndJoin')}</Button>
        </DialogActions>
    </Dialog>;
}
